class BackInStockForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");

    const currentVariantEl = this.querySelector(
      `[data-bis-variant-id="${this.form.variant.value}"]`,
    );

    if (currentVariantEl) {
      currentVariantEl.style.display = null;
    }

    this.form.addEventListener("submit", (e) => {
      e.preventDefault();
      this._clearError();

      const requests = [];

      const body = {
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            channels: ["EMAIL", "SMS"],
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: this.form.email.value,
                },
              },
            },
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: `$shopify:::$default:::${this.form.variant.value}`,
              },
            },
          },
        },
      };

      requests.push(
        fetch(this.form.action, {
          method: "POST",
          headers: {
            revision: "2025-01-15",
            "content-type": "application/json",
          },
          body: JSON.stringify(body),
        }).then((res) => {
          if (!res.ok) {
            throw new Error("Error adding to back in stock", res);
          }
        }),
      );

      if (this.form.dataset.listId) {
        const sendSubscribe = fetch(this.form.dataset.subscribeUrl, {
          method: "POST",
          headers: {
            revision: "2025-01-15",
            "content-type": "application/json",
          },
          body: JSON.stringify({
            data: {
              type: "subscription",
              attributes: {
                custom_source: "Back in stock form",
                profile: {
                  data: {
                    type: "profile",
                    attributes: {
                      email: this.form.email.value,
                    },
                  },
                },
              },
              relationships: {
                list: { data: { type: "list", id: this.form.dataset.listId } },
              },
            },
          }),
        });
        // This endpoint doesn't provide any response data

        requests.push(sendSubscribe);
      }

      Promise.all(requests)
        .then(() => this._setSuccess())
        .catch((err) => {
          console.log("err", err);
          this._setError();
        });
    });
  }

  _setSuccess() {
    this._clearError();
    this.querySelector(".bis-form__success").style.display = null;
    this.form.style.display = "none";
  }

  _setError() {
    this.querySelector(".bis-form__error").style.display = null;
  }

  _clearError() {
    this.querySelector(".bis-form__error").style.display = "none";
  }
}

if (!customElements.get("back-in-stock-form")) {
  customElements.define("back-in-stock-form", BackInStockForm);
}
